module.exports = __webpack_public_path__ + "static/media/hall-PC.bd9cd669.svg";